import { Text } from '@reveni-io/reveni-ui'

const Details = ({ isReturn, portalName, address }) => {
  if (isReturn) {
    return (
      <div>
        <Text type="bodyMRegular">{portalName}</Text>
      </div>
    )
  }

  return (
    <div>
      {address?.company && <Text type="bodyMRegular">{address.company}</Text>}
      <Text type="bodyMRegular">
        {address?.first_name} {address?.last_name}
      </Text>
      <Text type="bodyMRegular">
        {address?.line_1} {address?.line_2}
      </Text>
      <Text type="bodyMRegular">
        {address?.postcode} {address?.province?.name} {address?.locality}
      </Text>
      <Text type="bodyMRegular">{address?.country?.name}</Text>
    </div>
  )
}

export default Details
